
import { defineComponent, nextTick, reactive, ref, toRefs, watch, computed, ComputedRef, createVNode, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import conditionstockApi from '@/api/conditionstockApi'
import resultItem from './resultitem.vue'
import Nodata from '@/components/page/nodata.vue'
import { handleParams } from './handleParams'
import type { ResultItemDataType } from './typings'
import type { PropType } from 'vue'
export default defineComponent({
  components: { resultItem, Nodata },
  props: {
    theme: {
      type: String,
      default: () => {
        return 'light'
      }
    },
    radiovalue: {
      type: Number,
      default: () => {
        return null
      }
    },
    groups: {
      type: Array as PropType<ResultItemDataType[]>,
      default() {
        return []
      }
    },
    localData: {
      type: Object,
      default() {
        return null
      }
    }
  },
  setup(props: any, context) {
    type pageDataType = {
      active: number
      data: any
      getCalendarContainer: any | null
    }
    const route = useRoute()
    const store = useStore()
    const pageData: pageDataType = reactive({
      active: 0,
      data: [],
      // getCalendarContainer: (e: HTMLElement) => document.querySelector('.mygroup')
      getCalendarContainer: (e: HTMLElement) => e.parentNode
    })

    watch(
      () => props.localData,
      (val) => {
        if (val.noData || !val.active) {
          pageData.active = 0
        }
        pageData.active = val.active
        setTimeout(() => {
            if (props.radiovalue === 2 && props.groups.length) { // 刚打开软件的时候需要执行一次筛选
            const res = props.groups[pageData.active].result
            handleParams(res)
          }
        }, 500)
      }
    )
    function handleClick(e: any, idx: number, item: ResultItemDataType) {
      const card = document.querySelectorAll('.ant-card')[idx]
      const extra = card.querySelector('.ant-card-extra')
      if (extra && extra.contains(e.target)) {
        return
      }
      if (pageData.active === idx) return
      pageData.active = idx
      const { result } = item
      handleParams(result)
    }
    function deleteItem(idx: number, item: any) {
      const result = props.groups.filter((ele: ResultItemDataType) => ele.groupName !== item.groupName)
      const url = 'gw://funccall?funcname=OnWriteFundData;dirName=h5storagespace/conditionstock;fileName=condition.dat;condition=' + encodeURIComponent(JSON.stringify(result))
      window.open(url)
      if (pageData.active === idx) {
        let tempActiveIdx = pageData.active + 1
        if (props.groups.length === 1) {
          // 删除唯一的组合
          pageData.active = 0
          tempActiveIdx = 0
        } else if (props.groups.length - pageData.active === 1) {
          // 删除最后一个组合
          tempActiveIdx = pageData.active - 1
          pageData.active = pageData.active - 1
        }
        const res = props.groups[tempActiveIdx].result
        handleParams(res)
        context.emit('refreshList')
        return
      }
      context.emit('refreshList')
    }

    function edit(idx: number) {
      const res = props.groups[idx].result
      handleParams(res)
      context.emit('jumpTo', idx)
    }

    function defaultPost() {
      if (props.groups.length) {
        const { result } = props.groups[pageData.active]
        handleParams(result)
      }
    }
    watch(
      () => pageData.active,
      () => {
        const params = { active: pageData.active } // radiovalue: 2,
        context.emit('setLocalStorage', params)
      }
    )
    // 保存后跳转，需要把active置为0
    function setActive(num: number) {
      pageData.active = num
    }
    return {
      ...toRefs(pageData),
      deleteItem,
      edit,
      handleClick,
      defaultPost,
      setActive
    }
  }
})
